document.body.addEventListener('keyup', function (event) {
  const input = event.target;
  if (input.matches('input.search__input.field__input')) {
    const searchTerm = input.value.trim();

    const target = document.querySelector('.blog-banner-search-grid');
    if (!searchTerm) {
      if (target) target.innerHTML = ''; // Clear content if input is blank
      return;
    }

    const cstmUrl = `/search?q=${encodeURIComponent(searchTerm)}&type=article`;

    console.log('Fetching:', cstmUrl);

    fetch(cstmUrl)
      .then(response => response.text())
      .then(htmlText => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const resultsContent = doc.querySelector('.template-search__results');

        if (resultsContent && target) {
          target.innerHTML = resultsContent.innerHTML;
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });
  }
});
